import { Text, Flex, Icon } from '@pairy/pds-react';

import { Nullable } from '@/types/helper';
import { formatKoreanPhoneNumber } from '@/utils/formatPhone';

import * as Styled from './index.styles';

interface Props {
  name: Nullable<string>;
  email: Nullable<string>;
  company?: Nullable<string>;
  phone?: Nullable<string>;
  onClick: () => void;
}

const ClientBox = ({ name, email, company, phone, onClick }: Props) => {
  const displayName =
    name ||
    company ||
    (phone ? formatKoreanPhoneNumber(phone) : null) ||
    email ||
    '(이름 없음)';

  return (
    <Styled.ClientBox>
      <Flex justifyContent="space-between">
        <div>
          <Text as="p" variant="sm-medium" color="skyblue_500">
            {displayName}
          </Text>
          <Text as="p" variant="sm-regular" color="skyblue_500">
            {email ?? <br />}
          </Text>
        </div>
        <Styled.Button onClick={onClick}>
          <Icon icon="ph:x-light" size={14} color="skyblue_500" />
        </Styled.Button>
      </Flex>
    </Styled.ClientBox>
  );
};

export default ClientBox;
